export default function IntegrationBanner() {
  return (
    <section id="integration" className="relative scroll-mt-24 overflow-hidden isolate">
      <img
        src="/images/landing-v2/integration/background.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
      />
      <div className="relative mx-auto w-full max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8 lg:py-28">
        <h2 className="text-center text-[clamp(1.6rem,4.5vw,3rem)] font-semibold tracking-tight text-neutral-900">
          Stop <span className="text-[#0092B4]">losing hours</span> to busy work.
        </h2>
      </div>
    </section>
  );
}
